import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type StaffFunctionsFetchFailedAction = {
	type: 'STAFF_FUNCTIONS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): StaffFunctionsFetchFailedAction => ({
	type: 'STAFF_FUNCTIONS_FETCH_FAILED',
	payload,
});
